import React from 'react';
import { Switch, Route } from 'react-router-dom';

//Layouts
import NotFound from './NotFound';
import App from './App';
import Status from './Status';
import AllBooking from './AllBooking';
import Thanks from './Thanks';
import Wrapper from './Wrapper';

const Index = () => {
  const availablePublicRoutesPaths = [
    { path: '/', component: App },
    { path: '/status', component: Status },
    { path: '/bookings', component: AllBooking },
    { path: '/thanks', component: Thanks },
  ];

  return (
    <React.Fragment>
      <Route path={availablePublicRoutesPaths}>
        <Wrapper>
          <Switch>
            {availablePublicRoutesPaths.map((route, idx) => (
              <Route path={route.path} component={route.component} key={idx} exact={true} />
            ))}

            <Route component={NotFound} />
          </Switch>
        </Wrapper>
      </Route>
    </React.Fragment>
  );
};

export default Index;
